import Input from 'b2b-ui-components-lib/lib/components/input';
import { IFORM } from 'featureLib/FormBuilder';
import { alphaNumericValidatorWithSpecialCharacters, emailValidaotr, mobileValidator } from 'common/utils/validator';
// import ReferInput from './ReferInput';

export const REFER_BUSINESS: IFORM = {
  customerName: {
    key: 'customerName',
    isMandatory: true,
    value: '',
    label: 'Full Name',
    className: 'flg-lg-6 flg-md-6 flg-sm-12 field-control',
    validator: alphaNumericValidatorWithSpecialCharacters,
    element: {
      type: Input,
      props: {
        placeholder: 'E.g. Ramj Kumar'
      }
    }
  },
  phoneNumber: {
    key: 'mobileNumber',
    isMandatory: true,
    value: '',
    label: 'Mobile Number',
    className: 'flg-lg-6 flg-md-6 flg-sm-12 row_section',
    validator: mobileValidator,
    element: { type: Input, props: { placeholder: 'E.g. 8812345678' } }
  },
  emailAddress: {
    key: 'emailAddress',
    isMandatory: true,
    value: '',
    label: 'Email Address',
    className: 'flg-lg-6 flg-md-6 flg-sm-12',
    validator: emailValidaotr,
    element: { type: Input, props: { placeholder: 'E.g. abc@email.com' } }
  },
  companyName: {
    key: 'companyName',
    isMandatory: true,
    value: '',
    label: 'Company Name',
    className: 'flg-lg-6 flg-md-6 flg-sm-12',
    element: { type: Input, props: { placeholder: 'E.g. Abc Pvt Ltd' } }
  }
};
